module.exports = __webpack_public_path__ + "img/products/step-03@2x.png";